var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPNavBookOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 7.50001C12.75 4.53938 15.5827 3.02766 21.75 3.00001C21.8486 2.99963 21.9463 3.01878 22.0375 3.05634C22.1286 3.0939 22.2114 3.14913 22.2812 3.21885C22.3509 3.28856 22.4061 3.37139 22.4437 3.46255C22.4812 3.55372 22.5004 3.65141 22.5 3.75001V17.25C22.5 17.4489 22.421 17.6397 22.2803 17.7803C22.1397 17.921 21.9489 18 21.75 18C15.75 18 13.432 19.2098 12 21M12 7.50001C11.25 4.53938 8.41735 3.02766 2.25001 3.00001C2.15141 2.99963 2.05372 3.01878 1.96255 3.05634C1.87139 3.0939 1.78856 3.14913 1.71885 3.21885C1.64913 3.28856 1.5939 3.37139 1.55634 3.46255C1.51878 3.55372 1.49963 3.65141 1.50001 3.75001V17.1595C1.50001 17.6227 1.78688 18 2.25001 18C8.25001 18 10.5764 19.2188 12 21M12 7.50001V21",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPNavBookOutline);
export default __webpack_public_path__ + "static/media/p_nav_book_outline.fb050bf80ef766ae070729d9ee3e8039.svg";
export { ForwardRef as ReactComponent };